import { render } from "./app-form-company-annual-turnover.vue?vue&type=template&id=b1fcfe3c"
import script from "./app-form-company-annual-turnover.vue?vue&type=script&lang=js"
export * from "./app-form-company-annual-turnover.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/components/form/reference/app-form-company-annual-turnover.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1fcfe3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1fcfe3c', __exports__)) {
    console.log('reload')
    api.reload('b1fcfe3c', __exports__)
  }
  
  module.hot.accept("./app-form-company-annual-turnover.vue?vue&type=template&id=b1fcfe3c", () => {
    console.log('re-render')
    api.rerender('b1fcfe3c', render)
  })

}


export default __exports__